import { IconButton } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Icon from '@material-ui/core/Icon';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { MoreHorizOutlined } from '@material-ui/icons';
import Alert from '@material-ui/lab/Alert';
import * as React from 'react';
import { BasePlanModal } from 'v2/components/Shared/BasePlanModal';
import Truncate from 'v2/components/Shared/TruncateText';
import { formatMoney } from 'v2/helpers/money';

import { Header } from './Header';
import { useStyles } from './styles';

import type IProduct from 'interfaces/IProduct';

type BasePlanProps = {
  product: Partial<IProduct>;
  updateProduct: (product: Partial<IProduct>) => void;
};

function BasePlan({ product, updateProduct }: BasePlanProps) {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [openModal, setOpenModal] = React.useState(false);

  const handleActionsOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleEditClick = () => {
    setAnchorEl(null);
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  function getFrequencyType(type = 'M') {
    const frequencyText = {
      M: 'Mensal',
      TM: 'Trimestral',
      SM: 'Semestral',
      Y: 'Anual',
      P: 'Personalizado',
    };

    return frequencyText[type];
  }

  const brlProductPrice = product.prices.find((price) => price.currency_code === 'BRL');

  const hasBasePlan = !!product.plan_title;

  return (
    <div>
      <Header title={'Plano de assinatura'} />
      <p style={{ fontSize: 14, margin: '18px 0 18px 0' }}>
        Você precisa adicionar um plano para avançar. Atente-se, na criação do produto a quantidade máxima permitida é 01 plano.
      </p>
      {!hasBasePlan && (
        <Container className={classes.dashedContainer}>
          <Button id='new-product-add-plan-button' startIcon={<Icon>add</Icon>} onClick={() => setOpenModal(true)}>
            Adicionar Plano
          </Button>
        </Container>
      )}
      {hasBasePlan && (
        <>
          <TableContainer>
            <Table size='small'>
              <TableHead>
                <TableCell>Plano</TableCell>
                <TableCell width={110}>Frequência</TableCell>
                <TableCell width={110}>Valor</TableCell>
                <TableCell width={180}>Forma de cobrança</TableCell>
                <TableCell width={75} align='center' />
              </TableHead>
              <TableBody>
                <TableRow key={1}>
                  <TableCell style={{ whiteSpace: 'nowrap' }}>
                    <Truncate count={20} style={{ display: 'inline-block' }}>
                      {product.plan_title}
                    </Truncate>
                  </TableCell>
                  <TableCell>{getFrequencyType(product.recurring_frequency_type)}</TableCell>
                  <TableCell>{formatMoney(brlProductPrice?.value || 0)}</TableCell>
                  <TableCell>{product.undetermined_charges ? 'Infinita' : 'Finita'}</TableCell>
                  <TableCell align='right'>
                    <IconButton id={`offer-actions-${1}`} size='small' onClick={handleActionsOpen}>
                      <MoreHorizOutlined />
                    </IconButton>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <Alert severity='warning'>Para cadastrar mais planos, você precisa concluir o cadastro de produto.</Alert>
        </>
      )}
      <BasePlanModal open={openModal} handleClose={handleClose} product={product} updateProduct={updateProduct} />
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <MenuItem id='edit-plan-button' onClick={handleEditClick}>
          Editar
        </MenuItem>
      </Menu>
    </div>
  );
}

export { BasePlan };
